[
  {
    "codigo": "1000",
    "descricao": "ENTRADAS OU AQUISIÇÕES DE SERVIÇOS DO ESTADO"
  },
  {
    "codigo": "1100",
    "descricao": "COMPRAS PARA INDUSTRIALIZAÇÃO, PRODUÇÃO RURAL, COMERCIALIZAÇÃO OU PRESTAÇÃO DE SERVIÇOS"
  },
  {
    "codigo": "1101",
    "descricao": "Compra para industrialização ou produção rural"
  },
  {
    "codigo": "1102",
    "descricao": "Compra para comercialização"
  },
  {
    "codigo": "1111",
    "descricao": "Compra para industrialização de mercadoria recebida anteriormente em consignação industrial"
  },
  {
    "codigo": "1113",
    "descricao": "Compra para comercialização, de mercadoria recebida anteriormente em consignação mercantil"
  },
  {
    "codigo": "1116",
    "descricao": "Compra para industrialização ou produção rural originada de encomenda para recebimento futuro"
  },
  {
    "codigo": "1117",
    "descricao": "Compra para comercialização originada de encomenda para recebimento futuro"
  },
  {
    "codigo": "1118",
    "descricao": "Compra de mercadoria para comercialização pelo adquirente originário, entregue pelo vendedor remetente ao destinatário, em venda à ordem"
  },
  {
    "codigo": "1120",
    "descricao": "Compra para industrialização, em venda à ordem, já recebida do vendedor remetente"
  },
  {
    "codigo": "1121",
    "descricao": "Compra para comercialização, em venda à ordem, já recebida do vendedor remetente"
  },
  {
    "codigo": "1122",
    "descricao": "Compra para industrialização em que a mercadoria foi remetida pelo fornecedor ao industrializador sem transitar pelo estabelecimento adquirente"
  },
  {
    "codigo": "1124",
    "descricao": "Industrialização efetuada por outra empresa"
  },
  {
    "codigo": "1125",
    "descricao": "Industrialização efetuada por outra empresa quando a mercadoria remetida para utilização no processo de industrialização não transitou pelo estabelecimento adquirente da mercadoria"
  },
  {
    "codigo": "1126",
    "descricao": "Compra para utilização na prestação de serviço sujeita ao ICMS"
  },
  {
    "codigo": "1128",
    "descricao": "Compra para utilização na prestação de serviço sujeita ao ISSQN"
  },
  {
    "codigo": "1131",
    "descricao": "Entrada de mercadoria com previsão de posterior ajuste ou fixação de preço, decorrente de operação de ato cooperativo."
  },
  {
    "codigo": "1132",
    "descricao": "Fixação de preço de produção do estabelecimento produtor, inclusive quando remetidas anteriormente com previsão de posterior ajuste ou fixação de preço, em ato cooperativo, para comercialização."
  },
  {
    "codigo": "1135",
    "descricao": "Fixação de preço de produção do estabelecimento produtor, inclusive quando remetidas anteriormente com previsão de posterior ajuste ou fixação de preço, em ato cooperativo, para industrialização."
  },
  {
    "codigo": "1150",
    "descricao": "TRANSFERÊNCIAS PARA INDUSTRIALIZAÇÃO, PRODUÇÃO RURAL, COMERCIALIZAÇÃO OU PRESTAÇÃO DE SERVIÇOS"
  },
  {
    "codigo": "1151",
    "descricao": "Transferência para industrialização ou produção rural"
  },
  {
    "codigo": "1152",
    "descricao": "Transferência para comercialização"
  },
  {
    "codigo": "1153",
    "descricao": "Transferência de energia elétrica para distribuição"
  },
  {
    "codigo": "1154",
    "descricao": "Transferência para utilização na prestação de serviço"
  },
  {
    "codigo": "1159",
    "descricao": "Entrada decorrente do fornecimento de produto ou mercadoria de ato cooperativo"
  },
  {
    "codigo": "1200",
    "descricao": "DEVOLUÇÕES DE VENDAS DE PRODUÇÃO PRÓPRIA, DE TERCEIROS OU ANULAÇÕES DE VALORES"
  },
  {
    "codigo": "1201",
    "descricao": "Devolução de venda de produção do estabelecimento"
  },
  {
    "codigo": "1202",
    "descricao": "Devolução de venda de mercadoria adquirida ou recebida de terceiros"
  },
  {
    "codigo": "1203",
    "descricao": "Devolução de venda de produção do estabelecimento, destinada à Zona Franca de Manaus ou Áreas de Livre Comércio"
  },
  {
    "codigo": "1204",
    "descricao": "Devolução de venda de mercadoria adquirida ou recebida de terceiros, destinada à Zona Franca de Manaus ou Áreas de Livre Comércio"
  },
  {
    "codigo": "1205",
    "descricao": "Anulação de valor relativo à prestação de serviço de comunicação"
  },
  {
    "codigo": "1206",
    "descricao": "Anulação de valor relativo à prestação de serviço de transporte"
  },
  {
    "codigo": "1207",
    "descricao": "Anulação de valor relativo à venda de energia elétrica"
  },
  {
    "codigo": "1208",
    "descricao": "Devolução de produção do estabelecimento, remetida em transferência"
  },
  {
    "codigo": "1209",
    "descricao": "Devolução de mercadoria adquirida ou recebida de terceiros, remetida em transferência"
  },
  {
    "codigo": "1212",
    "descricao": "Devolução de venda no mercado interno de mercadoria industrializada e insumo importado sob o Regime Aduaneiro Especial de Entreposto Industrial sob Controle Informatizado do Sistema Público de Escrituração Digital (Recof-Sped)."
  },
  {
    "codigo": "1213",
    "descricao": "Devolução de remessa de produção do estabelecimento com previsão de posterior ajuste ou fixação de preço, em ato cooperativo."
  },
  {
    "codigo": "1214",
    "descricao": "Devolução de fixação de preço de produção do estabelecimento produtor, de ato cooperativo."
  },
  {
    "codigo": "1215",
    "descricao": "Devolução de fornecimento de produção do estabelecimento de ato cooperativo"
  },
  {
    "codigo": "1216",
    "descricao": "Devolução de fornecimento de mercadoria adquirida ou recebida de terceiros de ato cooperativo"
  },
  {
    "codigo": "1250",
    "descricao": "COMPRAS DE ENERGIA ELÉTRICA"
  },
  {
    "codigo": "1251",
    "descricao": "Compra de energia elétrica para distribuição ou comercialização"
  },
  {
    "codigo": "1252",
    "descricao": "Compra de energia elétrica por estabelecimento industrial"
  },
  {
    "codigo": "1253",
    "descricao": "Compra de energia elétrica por estabelecimento comercial"
  },
  {
    "codigo": "1254",
    "descricao": "Compra de energia elétrica por estabelecimento prestador de serviço de transporte"
  },
  {
    "codigo": "1255",
    "descricao": "Compra de energia elétrica por estabelecimento prestador de serviço de comunicação"
  },
  {
    "codigo": "1256",
    "descricao": "Compra de energia elétrica por estabelecimento de produtor rural"
  },
  {
    "codigo": "1257",
    "descricao": "Compra de energia elétrica para consumo por demanda contratada"
  },
  {
    "codigo": "1300",
    "descricao": "AQUISIÇÕES DE SERVIÇOS DE COMUNICAÇÃO"
  },
  {
    "codigo": "1301",
    "descricao": "Aquisição de serviço de comunicação para execução de serviço da mesma natureza"
  },
  {
    "codigo": "1302",
    "descricao": "Aquisição de serviço de comunicação por estabelecimento industrial"
  },
  {
    "codigo": "1303",
    "descricao": "Aquisição de serviço de comunicação por estabelecimento comercial"
  },
  {
    "codigo": "1304",
    "descricao": "Aquisição de serviço de comunicação por estabelecimento de prestador de serviço de transporte"
  },
  {
    "codigo": "1305",
    "descricao": "Aquisição de serviço de comunicação por estabelecimento de geradora ou de distribuidora de energia elétrica"
  },
  {
    "codigo": "1306",
    "descricao": "Aquisição de serviço de comunicação por estabelecimento de produtor rural"
  },
  {
    "codigo": "1351",
    "descricao": "Aquisição de serviço de transporte para execução de serviço da mesma natureza"
  },
  {
    "codigo": "1352",
    "descricao": "Aquisição de serviço de transporte por estabelecimento industrial"
  },
  {
    "codigo": "1353",
    "descricao": "Aquisição de serviço de transporte por estabelecimento comercial"
  },
  {
    "codigo": "1354",
    "descricao": "Aquisição de serviço de transporte por estabelecimento de prestador de serviço de comunicação"
  },
  {
    "codigo": "1355",
    "descricao": "Aquisição de serviço de transporte por estabelecimento de geradora ou de distribuidora de energia elétrica"
  },
  {
    "codigo": "1356",
    "descricao": "Aquisição de serviço de transporte por estabelecimento de produtor rural"
  },
  {
    "codigo": "1360",
    "descricao": "Aquisição de serviço de transporte por contribuinte substituto em relação ao serviço de transporte"
  },
  {
    "codigo": "1400",
    "descricao": "ENTRADAS DE MERCADORIAS SUJEITAS AO REGIME DE SUBSTITUIÇÃO TRIBUTÁRIA"
  },
  {
    "codigo": "1401",
    "descricao": "Compra para industrialização ou produção rural em operação com mercadoria sujeita ao regime de substituição tributária"
  },
  {
    "codigo": "1403",
    "descricao": "Compra para comercialização em operação com mercadoria sujeita ao regime de substituição tributária"
  },
  {
    "codigo": "1406",
    "descricao": "Compra de bem para o ativo imobilizado cuja mercadoria está sujeita ao regime de substituição tributária"
  },
  {
    "codigo": "1407",
    "descricao": "Compra de mercadoria para uso ou consumo cuja mercadoria está sujeita ao regime de substituição tributária"
  },
  {
    "codigo": "1408",
    "descricao": "Transferência para industrialização ou produção rural em operação com mercadoria sujeita ao regime de substituição tributária"
  },
  {
    "codigo": "1409",
    "descricao": "Transferência para comercialização em operação com mercadoria sujeita ao regime de substituição tributária"
  },
  {
    "codigo": "1410",
    "descricao": "Devolução de venda de produção do estabelecimento em operação com produto sujeito ao regime de substituição tributária"
  },
  {
    "codigo": "1411",
    "descricao": "Devolução de venda de mercadoria adquirida ou recebida de terceiros em operação com mercadoria sujeita ao regime de substituição tributária"
  },
  {
    "codigo": "1414",
    "descricao": "Retorno de produção do estabelecimento, remetida para venda fora do estabelecimento em operação com produto sujeito ao regime de substituição tributária"
  },
  {
    "codigo": "1415",
    "descricao": "Retorno de mercadoria adquirida ou recebida de terceiros, remetida para venda fora do estabelecimento em operação com mercadoria sujeita ao regime de substituição tributária"
  },
  {
    "codigo": "1450",
    "descricao": "SISTEMAS DE INTEGRAÇÃO E PARCERIA RURAL"
  },
  {
    "codigo": "1451",
    "descricao": "Entrada de animal - Sistema de Integração e Parceria Rural"
  },
  {
    "codigo": "1452",
    "descricao": "Entrada de insumo - Sistema de Integração e Parceria Rural"
  },
  {
    "codigo": "1453",
    "descricao": "Retorno do animal ou da produção - Sistema de Integração e Parceria Rural"
  },
  {
    "codigo": "1454",
    "descricao": "Retorno simbólico do animal ou da produção - Sistema de Integração e Parceria Rural"
  },
  {
    "codigo": "1455",
    "descricao": "Retorno de insumo não utilizado na produção - Sistema de Integração e Parceria Rural"
  },
  {
    "codigo": "1456",
    "descricao": "Entrada referente a remuneração do produtor no Sistema de Integração e Parceria Rural"
  },
  {
    "codigo": "1500",
    "descricao": "ENTRADAS DE MERCADORIAS REMETIDAS COM FIM ESPECÍFICO DE EXPORTAÇÃO E EVENTUAIS DEVOLUÇÕES"
  },
  {
    "codigo": "1501",
    "descricao": "Entrada de mercadoria recebida com fim específico de exportação"
  },
  {
    "codigo": "1503",
    "descricao": "Entrada decorrente de devolução de produto remetido com fim específico de exportação, de produção do estabelecimento"
  },
  {
    "codigo": "1504",
    "descricao": "Entrada decorrente de devolução de mercadoria remetida com fim específico de exportação, adquirida ou recebida de terceiros"
  },
  {
    "codigo": "1505",
    "descricao": "Entrada decorrente de devolução de mercadorias remetidas para formação de lote de exportação, de produtos industrializados ou produzidos pelo próprio estabelecimento"
  },
  {
    "codigo": "1506",
    "descricao": "Entrada decorrente de devolução de mercadorias, adquiridas ou recebidas de terceiros, remetidas para formação de lote de exportação"
  },
  {
    "codigo": "1550",
    "descricao": "OPERAÇÕES COM BENS DE ATIVO IMOBILIZADO E MATERIAIS PARA USO OU CONSUMO"
  },
  {
    "codigo": "1551",
    "descricao": "Compra de bem para o ativo imobilizado"
  },
  {
    "codigo": "1552",
    "descricao": "Transferência de bem do ativo imobilizado"
  },
  {
    "codigo": "1553",
    "descricao": "Devolução de venda de bem do ativo imobilizado"
  },
  {
    "codigo": "1554",
    "descricao": "Retorno de bem do ativo imobilizado remetido para uso fora do estabelecimento"
  },
  {
    "codigo": "1555",
    "descricao": "Entrada de bem do ativo imobilizado de terceiro, remetido para uso no estabelecimento"
  },
  {
    "codigo": "1556",
    "descricao": "Compra de material para uso ou consumo"
  },
  {
    "codigo": "1557",
    "descricao": "Transferência de material para uso ou consumo"
  },
  {
    "codigo": "1600",
    "descricao": "CRÉDITOS E RESSARCIMENTOS DE ICMS"
  },
  {
    "codigo": "1601",
    "descricao": "Recebimento, por transferência, de crédito de ICMS"
  },
  {
    "codigo": "1602",
    "descricao": "Recebimento, por transferência, de saldo credor de ICMS de outro estabelecimento da mesma empresa, para compensação de saldo devedor de ICMS"
  },
  {
    "codigo": "1603",
    "descricao": "Ressarcimento de ICMS retido por substituição tributária"
  },
  {
    "codigo": "1604",
    "descricao": "Lançamento do crédito relativo à compra de bem para o ativo imobilizado"
  },
  {
    "codigo": "1605",
    "descricao": "Recebimento, por transferência, de saldo devedor de ICMS de outro estabelecimento da mesma empresa."
  },
  {
    "codigo": "1650",
    "descricao": "ENTRADAS DE COMBUSTÍVEIS, DERIVADOS OU NÃO DE PETRÓLEO E LUBRIFICANTES"
  },
  {
    "codigo": "1651",
    "descricao": "Compra de combustível ou lubrificante para industrialização subseqüente"
  },
  {
    "codigo": "1652",
    "descricao": "Compra de combustível ou lubrificante para comercialização"
  },
  {
    "codigo": "1653",
    "descricao": "Compra de combustível ou lubrificante por consumidor ou usuário final"
  },
  {
    "codigo": "1657",
    "descricao": "Retorno de remessa de combustível ou lubrificante para venda fora do estabelecimento."
  },
  {
    "codigo": "1658",
    "descricao": "Transferência de combustível e lubrificante para industrialização"
  },
  {
    "codigo": "1659",
    "descricao": "Transferência de combustível e lubrificante para comercialização"
  },
  {
    "codigo": "1660",
    "descricao": "Devolução de venda de combustível ou lubrificante destinado à industrialização subseqüente"
  },
  {
    "codigo": "1661",
    "descricao": "Devolução de venda de combustível ou lubrificante destinado à comercialização"
  },
  {
    "codigo": "1662",
    "descricao": "Devolução de venda de combustível ou lubrificante destinado a consumidor ou usuário final"
  },
  {
    "codigo": "1663",
    "descricao": "Entrada de combustível ou lubrificante para armazenagem"
  },
  {
    "codigo": "1664",
    "descricao": "Retorno de combustível ou lubrificante remetido para armazenagem"
  },
  {
    "codigo": "1900",
    "descricao": "OUTRAS ENTRADAS DE MERCADORIAS OU AQUISIÇÕES DE SERVIÇOS"
  },
  {
    "codigo": "1901",
    "descricao": "Entrada para industrialização por encomenda"
  },
  {
    "codigo": "1902",
    "descricao": "Retorno de mercadoria remetida para industrialização por encomenda"
  },
  {
    "codigo": "1903",
    "descricao": "Entrada de mercadoria remetida para industrialização e não aplicada no referido processo"
  },
  {
    "codigo": "1904",
    "descricao": "Retorno de remessa para venda fora do estabelecimento"
  },
  {
    "codigo": "1905",
    "descricao": "Entrada de mercadoria recebida para depósito em depósito fechado ou armazém geral"
  },
  {
    "codigo": "1906",
    "descricao": "Retorno de mercadoria remetida para depósito fechado ou armazém geral"
  },
  {
    "codigo": "1907",
    "descricao": "Retorno simbólico de mercadoria remetida para depósito fechado ou armazém geral"
  },
  {
    "codigo": "1908",
    "descricao": "Entrada de bem por conta de contrato de comodato ou locação"
  },
  {
    "codigo": "1909",
    "descricao": "Retorno de bem remetido por conta de contrato de comodato ou locação"
  },
  {
    "codigo": "1910",
    "descricao": "Entrada de bonificação, doação ou brinde"
  },
  {
    "codigo": "1911",
    "descricao": "Entrada de amostra grátis"
  },
  {
    "codigo": "1912",
    "descricao": "Entrada de mercadoria ou bem recebido para demonstração"
  },
  {
    "codigo": "1913",
    "descricao": "Retorno de mercadoria ou bem remetido para demonstração"
  },
  {
    "codigo": "1914",
    "descricao": "Retorno de mercadoria ou bem remetido para exposição ou feira"
  },
  {
    "codigo": "1915",
    "descricao": "Entrada de mercadoria ou bem recebido para conserto ou reparo"
  },
  {
    "codigo": "1916",
    "descricao": "Retorno de mercadoria ou bem remetido para conserto ou reparo"
  },
  {
    "codigo": "1917",
    "descricao": "Entrada de mercadoria recebida em consignação mercantil ou industrial"
  },
  {
    "codigo": "1918",
    "descricao": "Devolução de mercadoria remetida em consignação mercantil ou industrial"
  },
  {
    "codigo": "1919",
    "descricao": "Devolução simbólica de mercadoria vendida ou utilizada em processo industrial, remetida anteriormente em consignação mercantil ou industrial"
  },
  {
    "codigo": "1920",
    "descricao": "Entrada de vasilhame ou sacaria"
  },
  {
    "codigo": "1921",
    "descricao": "Retorno de vasilhame ou sacaria"
  },
  {
    "codigo": "1922",
    "descricao": "Lançamento efetuado a título de simples faturamento decorrente de compra para recebimento futuro"
  },
  {
    "codigo": "1923",
    "descricao": "Entrada de mercadoria recebida do vendedor remetente, em venda à ordem"
  },
  {
    "codigo": "1924",
    "descricao": "Entrada para industrialização por conta e ordem do adquirente da mercadoria, quando esta não transitar pelo estabelecimento do adquirente"
  },
  {
    "codigo": "1925",
    "descricao": "Retorno de mercadoria remetida para industrialização por conta e ordem do adquirente da mercadoria, quando esta não transitar pelo estabelecimento do adquirente"
  },
  {
    "codigo": "1926",
    "descricao": "Lançamento efetuado a título de reclassificação de mercadoria decorrente de formação de kit ou de sua desagregação"
  },
  {
    "codigo": "1931",
    "descricao": "Lançamento efetuado pelo tomador do serviço de transporte quando a responsabilidade de retenção do imposto for atribuída ao remetente ou alienante da mercadoria, pelo serviço de transporte realizado por transportador autônomo ou por transportador não inscrito na unidade da Federação onde iniciado o serviço."
  },
  {
    "codigo": "1932",
    "descricao": "Aquisição de serviço de transporte iniciado em unidade da Federação diversa daquela onde inscrito o prestador."
  },
  {
    "codigo": "1933",
    "descricao": "Aquisição de serviço tributado pelo ISSQN"
  },
  {
    "codigo": "1934",
    "descricao": "Entrada simbólica de mercadoria recebida para depósito fechado ou armazém geral"
  },
  {
    "codigo": "1949",
    "descricao": "Outra entrada de mercadoria ou prestação de serviço não especificada"
  },
  {
    "codigo": "2000",
    "descricao": "ENTRADAS OU AQUISIÇÕES DE SERVIÇOS DE OUTROS ESTADOS"
  },
  {
    "codigo": "2100",
    "descricao": "COMPRAS PARA INDUSTRIALIZAÇÃO, PRODUÇÃO RURAL, COMERCIALIZAÇÃO OU PRESTAÇÃO DE SERVIÇOS"
  },
  {
    "codigo": "2101",
    "descricao": "Compra para industrialização ou produção rural"
  },
  {
    "codigo": "2102",
    "descricao": "Compra para comercialização"
  },
  {
    "codigo": "2111",
    "descricao": "Compra para industrialização de mercadoria recebida anteriormente em consignação industrial"
  },
  {
    "codigo": "2113",
    "descricao": "Compra para comercialização, de mercadoria recebida anteriormente em consignação mercantil"
  },
  {
    "codigo": "2116",
    "descricao": "Compra para industrialização ou produção rural originada de encomenda para recebimento futuro"
  },
  {
    "codigo": "2117",
    "descricao": "Compra para comercialização originada de encomenda para recebimento futuro"
  },
  {
    "codigo": "2118",
    "descricao": "Compra de mercadoria para comercialização pelo adquirente originário, entregue pelo vendedor remetente ao destinatário, em venda à ordem"
  },
  {
    "codigo": "2120",
    "descricao": "Compra para industrialização, em venda à ordem, já recebida do vendedor remetente"
  },
  {
    "codigo": "2121",
    "descricao": "Compra para comercialização, em venda à ordem, já recebida do vendedor remetente"
  },
  {
    "codigo": "2122",
    "descricao": "Compra para industrialização em que a mercadoria foi remetida pelo fornecedor ao industrializador sem transitar pelo estabelecimento adquirente"
  },
  {
    "codigo": "2124",
    "descricao": "Industrialização efetuada por outra empresa"
  },
  {
    "codigo": "2125",
    "descricao": "Industrialização efetuada por outra empresa quando a mercadoria remetida para utilização no processo de industrialização não transitou pelo estabelecimento adquirente da mercadoria"
  },
  {
    "codigo": "2126",
    "descricao": "Compra para utilização na prestação de serviço sujeita ao ICMS"
  },
  {
    "codigo": "2128",
    "descricao": "Compra para utilização na prestação de serviço sujeita ao ISSQN"
  },
  {
    "codigo": "2131",
    "descricao": "Entrada de mercadoria com previsão de posterior ajuste ou fixação de preço, decorrente de operação de ato cooperativo."
  },
  {
    "codigo": "2132",
    "descricao": "Fixação de preço de produção do estabelecimento produtor, inclusive quando remetidas anteriormente com previsão de posterior ajuste ou fixação de preço, em ato cooperativo, para comercialização."
  },
  {
    "codigo": "2135",
    "descricao": "Fixação de preço de produção do estabelecimento produtor, inclusive quando remetidas anteriormente com previsão de posterior ajuste ou fixação de preço, em ato cooperativo, para industrialização."
  },
  {
    "codigo": "2150",
    "descricao": "TRANSFERÊNCIAS PARA INDUSTRIALIZAÇÃO, PRODUÇÃO RURAL, COMERCIALIZAÇÃO OU PRESTAÇÃO DE SERVIÇOS"
  },
  {
    "codigo": "2151",
    "descricao": "Transferência para industrialização ou produção rural"
  },
  {
    "codigo": "2152",
    "descricao": "Transferência para comercialização"
  },
  {
    "codigo": "2153",
    "descricao": "Transferência de energia elétrica para distribuição"
  },
  {
    "codigo": "2154",
    "descricao": "Transferência para utilização na prestação de serviço"
  },
  {
    "codigo": "2159",
    "descricao": "Entrada decorrente do fornecimento de produto ou mercadoria de ato cooperativo"
  },
  {
    "codigo": "2200",
    "descricao": "DEVOLUÇÕES DE VENDAS DE PRODUÇÃO PRÓPRIA, DE TERCEIROS OU ANULAÇÕES DE VALORES"
  },
  {
    "codigo": "2201",
    "descricao": "Devolução de venda de produção do estabelecimento"
  },
  {
    "codigo": "2202",
    "descricao": "Devolução de venda de mercadoria adquirida ou recebida de terceiros"
  },
  {
    "codigo": "2203",
    "descricao": "Devolução de venda de produção do estabelecimento, destinada à Zona Franca de Manaus ou Áreas de Livre Comércio"
  },
  {
    "codigo": "2204",
    "descricao": "Devolução de venda de mercadoria adquirida ou recebida de terceiros, destinada à Zona Franca de Manaus ou Áreas de Livre Comércio"
  },
  {
    "codigo": "2205",
    "descricao": "Anulação de valor relativo à prestação de serviço de comunicação"
  },
  {
    "codigo": "2206",
    "descricao": "Anulação de valor relativo à prestação de serviço de transporte"
  },
  {
    "codigo": "2207",
    "descricao": "Anulação de valor relativo à venda de energia elétrica"
  },
  {
    "codigo": "2208",
    "descricao": "Devolução de produção do estabelecimento, remetida em transferência"
  },
  {
    "codigo": "2209",
    "descricao": "Devolução de mercadoria adquirida ou recebida de terceiros, remetida em transferência"
  },
  {
    "codigo": "2212",
    "descricao": "Devolução de venda no mercado interno de mercadoria industrializada e insumo importado sob o Regime Aduaneiro Especial de Entreposto Industrial sob Controle Informatizado do Sistema Público de Escrituração Digital (Recof-Sped)."
  },
  {
    "codigo": "2213",
    "descricao": "Devolução de remessa de produção do estabelecimento com previsão de posterior ajuste ou fixação de preço, em ato cooperativo."
  },
  {
    "codigo": "2214",
    "descricao": "Devolução de fixação de preço de produção do estabelecimento produtor, de ato cooperativo."
  },
  {
    "codigo": "2215",
    "descricao": "Devolução de fornecimento de produção do estabelecimento de ato cooperativo"
  },
  {
    "codigo": "2216",
    "descricao": "Devolução de fornecimento de mercadoria adquirida ou recebida de terceiros de ato cooperativo"
  },
  {
    "codigo": "2250",
    "descricao": "COMPRAS DE ENERGIA ELÉTRICA"
  },
  {
    "codigo": "2251",
    "descricao": "Compra de energia elétrica para distribuição ou comercialização"
  },
  {
    "codigo": "2252",
    "descricao": "Compra de energia elétrica por estabelecimento industrial"
  },
  {
    "codigo": "2253",
    "descricao": "Compra de energia elétrica por estabelecimento comercial"
  },
  {
    "codigo": "2254",
    "descricao": "Compra de energia elétrica por estabelecimento prestador de serviço de transporte"
  },
  {
    "codigo": "2255",
    "descricao": "Compra de energia elétrica por estabelecimento prestador de serviço de comunicação"
  },
  {
    "codigo": "2256",
    "descricao": "Compra de energia elétrica por estabelecimento de produtor rural"
  },
  {
    "codigo": "2257",
    "descricao": "Compra de energia elétrica para consumo por demanda contratada"
  },
  {
    "codigo": "2300",
    "descricao": "AQUISIÇÕES DE SERVIÇOS DE COMUNICAÇÃO"
  },
  {
    "codigo": "2301",
    "descricao": "Aquisição de serviço de comunicação para execução de serviço da mesma natureza"
  },
  {
    "codigo": "2302",
    "descricao": "Aquisição de serviço de comunicação por estabelecimento industrial"
  },
  {
    "codigo": "2303",
    "descricao": "Aquisição de serviço de comunicação por estabelecimento comercial"
  },
  {
    "codigo": "2304",
    "descricao": "Aquisição de serviço de comunicação por estabelecimento de prestador de serviço de transporte"
  },
  {
    "codigo": "2305",
    "descricao": "Aquisição de serviço de comunicação por estabelecimento de geradora ou de distribuidora de energia elétrica"
  },
  {
    "codigo": "2306",
    "descricao": "Aquisição de serviço de comunicação por estabelecimento de produtor rural"
  },
  {
    "codigo": "2350",
    "descricao": "AQUISIÇÕES DE SERVIÇOS DE TRANSPORTE"
  },
  {
    "codigo": "2351",
    "descricao": "Aquisição de serviço de transporte para execução de serviço da mesma natureza"
  },
  {
    "codigo": "2352",
    "descricao": "Aquisição de serviço de transporte por estabelecimento industrial"
  },
  {
    "codigo": "2353",
    "descricao": "Aquisição de serviço de transporte por estabelecimento comercial"
  },
  {
    "codigo": "2354",
    "descricao": "Aquisição de serviço de transporte por estabelecimento de prestador de serviço de comunicação"
  },
  {
    "codigo": "2355",
    "descricao": "Aquisição de serviço de transporte por estabelecimento de geradora ou de distribuidora de energia elétrica"
  },
  {
    "codigo": "2356",
    "descricao": "Aquisição de serviço de transporte por estabelecimento de produtor rural"
  },
  {
    "codigo": "2400",
    "descricao": "ENTRADAS DE MERCADORIAS SUJEITAS AO REGIME DE SUBSTITUIÇÃO TRIBUTÁRIA"
  },
  {
    "codigo": "2401",
    "descricao": "Compra para industrialização ou produção rural em operação com mercadoria sujeita ao regime de substituição tributária"
  },
  {
    "codigo": "2403",
    "descricao": "Compra para comercialização em operação com mercadoria sujeita ao regime de substituição tributária"
  },
  {
    "codigo": "2406",
    "descricao": "Compra de bem para o ativo imobilizado cuja mercadoria está sujeita ao regime de substituição tributária"
  },
  {
    "codigo": "2407",
    "descricao": "Compra de mercadoria para uso ou consumo cuja mercadoria está sujeita ao regime de substituição tributária"
  },
  {
    "codigo": "2408",
    "descricao": "Transferência para industrialização ou produção rural em operação com mercadoria sujeita ao regime de substituição tributária"
  },
  {
    "codigo": "2409",
    "descricao": "Transferência para comercialização em operação com mercadoria sujeita ao regime de substituição tributária"
  },
  {
    "codigo": "2410",
    "descricao": "Devolução de venda de produção do estabelecimento em operação com produto sujeito ao regime de substituição tributária"
  },
  {
    "codigo": "2411",
    "descricao": "Devolução de venda de mercadoria adquirida ou recebida de terceiros em operação com mercadoria sujeita ao regime de substituição tributária"
  },
  {
    "codigo": "2414",
    "descricao": "Retorno de produção do estabelecimento, remetida para venda fora do estabelecimento em operação com produto sujeito ao regime de substituição tributária"
  },
  {
    "codigo": "2415",
    "descricao": "Retorno de mercadoria adquirida ou recebida de terceiros, remetida para venda fora do estabelecimento em operação com mercadoria sujeita ao regime de substituição tributária"
  },
  {
    "codigo": "2450",
    "descricao": "SISTEMAS DE INTEGRAÇÃO E PARCERIA RURAL"
  },
  {
    "codigo": "2451",
    "descricao": "Entrada de animal - Sistema de Integração e Parceria Rural"
  },
  {
    "codigo": "2452",
    "descricao": "Entrada de insumo - Sistema de Integração e Parceria Rural"
  },
  {
    "codigo": "2453",
    "descricao": "Retorno do animal ou da produção - Sistema de Integração e Parceria Rural."
  },
  {
    "codigo": "2454",
    "descricao": "Retorno simbólico do animal ou da produção - Sistema de Integração e Parceria Rural."
  },
  {
    "codigo": "2455",
    "descricao": "Retorno de insumo não utilizado na produção - Sistema de Integração e Parceria Rural"
  },
  {
    "codigo": "2456",
    "descricao": "Entrada referente a remuneração do produtor no Sistema de Integração e Parceria Rural"
  },
  {
    "codigo": "2500",
    "descricao": "ENTRADAS DE MERCADORIAS REMETIDAS COM FIM ESPECÍFICO DE EXPORTAÇÃO E EVENTUAIS DEVOLUÇÕES"
  },
  {
    "codigo": "2501",
    "descricao": "Entrada de mercadoria recebida com fim específico de exportação"
  },
  {
    "codigo": "2503",
    "descricao": "Entrada decorrente de devolução de produto remetido com fim específico de exportação, de produção do estabelecimento"
  },
  {
    "codigo": "2504",
    "descricao": "Entrada decorrente de devolução de mercadoria remetida com fim específico de exportação, adquirida ou recebida de terceiros"
  },
  {
    "codigo": "2505",
    "descricao": "Entrada decorrente de devolução de mercadorias remetidas para formação de lote de exportação, de produtos industrializados ou produzidos pelo próprio estabelecimento"
  },
  {
    "codigo": "2506",
    "descricao": "Entrada decorrente de devolução de mercadorias, adquiridas ou recebidas de terceiros, remetidas para formação de lote de exportação"
  },
  {
    "codigo": "2550",
    "descricao": "OPERAÇÕES COM BENS DE ATIVO IMOBILIZADO E MATERIAIS PARA USO OU CONSUMO"
  },
  {
    "codigo": "2551",
    "descricao": "Compra de bem para o ativo imobilizado"
  },
  {
    "codigo": "2552",
    "descricao": "Transferência de bem do ativo imobilizado"
  },
  {
    "codigo": "2553",
    "descricao": "Devolução de venda de bem do ativo imobilizado"
  },
  {
    "codigo": "2554",
    "descricao": "Retorno de bem do ativo imobilizado remetido para uso fora do estabelecimento"
  },
  {
    "codigo": "2555",
    "descricao": "Entrada de bem do ativo imobilizado de terceiro, remetido para uso no estabelecimento"
  },
  {
    "codigo": "2556",
    "descricao": "Compra de material para uso ou consumo"
  },
  {
    "codigo": "2557",
    "descricao": "Transferência de material para uso ou consumo"
  },
  {
    "codigo": "2600",
    "descricao": "CRÉDITOS E RESSARCIMENTOS DE ICMS"
  },
  {
    "codigo": "2603",
    "descricao": "Ressarcimento de ICMS retido por substituição tributária"
  },
  {
    "codigo": "2650",
    "descricao": "ENTRADAS DE COMBUSTÍVEIS, DERIVADOS OU NÃO DE PETRÓLEO E LUBRIFICANTES"
  },
  {
    "codigo": "2651",
    "descricao": "Compra de combustível ou lubrificante para industrialização subseqüente"
  },
  {
    "codigo": "2652",
    "descricao": "Compra de combustível ou lubrificante para comercialização"
  },
  {
    "codigo": "2653",
    "descricao": "Compra de combustível ou lubrificante por consumidor ou usuário final"
  },
  {
    "codigo": "2657",
    "descricao": "Retorno de remessa de combustível ou lubrificante para venda fora do estabelecimento."
  },
  {
    "codigo": "2658",
    "descricao": "Transferência de combustível e lubrificante para industrialização"
  },
  {
    "codigo": "2659",
    "descricao": "Transferência de combustível e lubrificante para comercialização"
  },
  {
    "codigo": "2660",
    "descricao": "Devolução de venda de combustível ou lubrificante destinado à industrialização subseqüente"
  },
  {
    "codigo": "2661",
    "descricao": "Devolução de venda de combustível ou lubrificante destinado à comercialização"
  },
  {
    "codigo": "2662",
    "descricao": "Devolução de venda de combustível ou lubrificante destinado a consumidor ou usuário final"
  },
  {
    "codigo": "2663",
    "descricao": "Entrada de combustível ou lubrificante para armazenagem"
  },
  {
    "codigo": "2664",
    "descricao": "Retorno de combustível ou lubrificante remetido para armazenagem"
  },
  {
    "codigo": "2900",
    "descricao": "OUTRAS ENTRADAS DE MERCADORIAS OU AQUISIÇÕES DE SERVIÇOS"
  },
  {
    "codigo": "2901",
    "descricao": "Entrada para industrialização por encomenda"
  },
  {
    "codigo": "2902",
    "descricao": "Retorno de mercadoria remetida para industrialização por encomenda"
  },
  {
    "codigo": "2903",
    "descricao": "Entrada de mercadoria remetida para industrialização e não aplicada no referido processo"
  },
  {
    "codigo": "2904",
    "descricao": "Retorno de remessa para venda fora do estabelecimento"
  },
  {
    "codigo": "2905",
    "descricao": "Entrada de mercadoria recebida para depósito em depósito fechado ou armazém geral"
  },
  {
    "codigo": "2906",
    "descricao": "Retorno de mercadoria remetida para depósito fechado ou armazém geral"
  },
  {
    "codigo": "2907",
    "descricao": "Retorno simbólico de mercadoria remetida para depósito fechado ou armazém geral"
  },
  {
    "codigo": "2908",
    "descricao": "Entrada de bem por conta de contrato de comodato ou locação"
  },
  {
    "codigo": "2909",
    "descricao": "Retorno de bem remetido por conta de contrato de comodato ou locação"
  },
  {
    "codigo": "2910",
    "descricao": "Entrada de bonificação, doação ou brinde"
  },
  {
    "codigo": "2911",
    "descricao": "Entrada de amostra grátis"
  },
  {
    "codigo": "2912",
    "descricao": "Entrada de mercadoria ou bem recebido para demonstração"
  },
  {
    "codigo": "2913",
    "descricao": "Retorno de mercadoria ou bem remetido para demonstração"
  },
  {
    "codigo": "2914",
    "descricao": "Retorno de mercadoria ou bem remetido para exposição ou feira"
  },
  {
    "codigo": "2915",
    "descricao": "Entrada de mercadoria ou bem recebido para conserto ou reparo"
  },
  {
    "codigo": "2916",
    "descricao": "Retorno de mercadoria ou bem remetido para conserto ou reparo"
  },
  {
    "codigo": "2917",
    "descricao": "Entrada de mercadoria recebida em consignação mercantil ou industrial"
  },
  {
    "codigo": "2918",
    "descricao": "Devolução de mercadoria remetida em consignação mercantil ou industrial"
  },
  {
    "codigo": "2919",
    "descricao": "Devolução simbólica de mercadoria vendida ou utilizada em processo industrial, remetida anteriormente em consignação mercantil ou industrial"
  },
  {
    "codigo": "2920",
    "descricao": "Entrada de vasilhame ou sacaria"
  },
  {
    "codigo": "2921",
    "descricao": "Retorno de vasilhame ou sacaria"
  },
  {
    "codigo": "2922",
    "descricao": "Lançamento efetuado a título de simples faturamento decorrente de compra para recebimento futuro"
  },
  {
    "codigo": "2923",
    "descricao": "Entrada de mercadoria recebida do vendedor remetente, em venda à ordem"
  },
  {
    "codigo": "2924",
    "descricao": "Entrada para industrialização por conta e ordem do adquirente da mercadoria, quando esta não transitar pelo estabelecimento do adquirente"
  },
  {
    "codigo": "2925",
    "descricao": "Retorno de mercadoria remetida para industrialização por conta e ordem do adquirente da mercadoria, quando esta não transitar pelo estabelecimento do adquirente"
  },
  {
    "codigo": "2931",
    "descricao": "Lançamento efetuado pelo tomador do serviço de transporte quando a responsabilidade de retenção do imposto for atribuída ao remetente ou alienante da mercadoria, pelo serviço de transporte realizado por transportador autônomo ou por transportador não inscrito na unidade da Federação onde iniciado o serviço."
  },
  {
    "codigo": "2932",
    "descricao": "Aquisição de serviço de transporte iniciado em unidade da Federação diversa daquela onde inscrito o prestador."
  },
  {
    "codigo": "2933",
    "descricao": "Aquisição de serviço tributado pelo ISSQN"
  },
  {
    "codigo": "2934",
    "descricao": "Entrada simbólica de mercadoria recebida para depósito fechado ou armazém geral"
  },
  {
    "codigo": "2949",
    "descricao": "Outra entrada de mercadoria ou prestação de serviço não especificado"
  },
  {
    "codigo": "3000",
    "descricao": "ENTRADAS OU AQUISIÇÕES DE SERVIÇOS DO EXTERIOR"
  },
  {
    "codigo": "3100",
    "descricao": "COMPRAS PARA INDUSTRIALIZAÇÃO, PRODUÇÃO RURAL, COMERCIALIZAÇÃO OU PRESTAÇÃO DE SERVIÇOS"
  },
  {
    "codigo": "3101",
    "descricao": "Compra para industrialização ou produção rural"
  },
  {
    "codigo": "3102",
    "descricao": "Compra para comercialização"
  },
  {
    "codigo": "3126",
    "descricao": "Compra para utilização na prestação de serviço sujeita ao ICMS"
  },
  {
    "codigo": "3127",
    "descricao": "Compra para industrialização sob o regime de “drawback”"
  },
  {
    "codigo": "3128",
    "descricao": "Compra para utilização na prestação de serviço sujeita ao ISSQN"
  },
  {
    "codigo": "3129",
    "descricao": "Compra para industrialização sob o Regime Aduaneiro Especial de Entreposto Industrial sob Controle Informatizado do Sistema Público de Escrituração Digital (Recof-Sped)."
  },
  {
    "codigo": "3200",
    "descricao": "DEVOLUÇÕES DE VENDAS DE PRODUÇÃO PRÓPRIA, DE TERCEIROS OU ANULAÇÕES DE VALORES"
  },
  {
    "codigo": "3201",
    "descricao": "Devolução de venda de produção do estabelecimento"
  },
  {
    "codigo": "3202",
    "descricao": "Devolução de venda de mercadoria adquirida ou recebida de terceiros"
  },
  {
    "codigo": "3205",
    "descricao": "Anulação de valor relativo à prestação de serviço de comunicação"
  },
  {
    "codigo": "3206",
    "descricao": "Anulação de valor relativo à prestação de serviço de transporte"
  },
  {
    "codigo": "3207",
    "descricao": "Anulação de valor relativo à venda de energia elétrica"
  },
  {
    "codigo": "3211",
    "descricao": "Devolução de venda de produção do estabelecimento sob o regime de “drawback”"
  },
  {
    "codigo": "3212",
    "descricao": "Devolução de venda no mercado externo de mercadoria industrializada sob o Regime Aduaneiro Especial de Entreposto Industrial sob Controle Informatizado do Sistema Público de Escrituração Digital (Recof-Sped)."
  },
  {
    "codigo": "3250",
    "descricao": "COMPRAS DE ENERGIA ELÉTRICA"
  },
  {
    "codigo": "3251",
    "descricao": "Compra de energia elétrica para distribuição ou comercialização"
  },
  {
    "codigo": "3300",
    "descricao": "AQUISIÇÕES DE SERVIÇOS DE COMUNICAÇÃO"
  },
  {
    "codigo": "3301",
    "descricao": "Aquisição de serviço de comunicação para execução de serviço da mesma natureza"
  },
  {
    "codigo": "3350",
    "descricao": "AQUISIÇÕES DE SERVIÇOS DE TRANSPORTE"
  },
  {
    "codigo": "3351",
    "descricao": "Aquisição de serviço de transporte para execução de serviço da mesma natureza"
  },
  {
    "codigo": "3352",
    "descricao": "Aquisição de serviço de transporte por estabelecimento industrial"
  },
  {
    "codigo": "3353",
    "descricao": "Aquisição de serviço de transporte por estabelecimento comercial"
  },
  {
    "codigo": "3354",
    "descricao": "Aquisição de serviço de transporte por estabelecimento de prestador de serviço de comunicação"
  },
  {
    "codigo": "3355",
    "descricao": "Aquisição de serviço de transporte por estabelecimento de geradora ou de distribuidora de energia elétrica"
  },
  {
    "codigo": "3356",
    "descricao": "Aquisição de serviço de transporte por estabelecimento de produtor rural"
  },
  {
    "codigo": "3500",
    "descricao": "ENTRADAS DE MERCADORIAS REMETIDAS COM FIM ESPECÍFICO DE EXPORTAÇÃO E EVENTUAIS DEVOLUÇÕES"
  },
  {
    "codigo": "3503",
    "descricao": "Devolução de mercadoria exportada que tenha sido recebida com fim específico de exportação"
  },
  {
    "codigo": "3550",
    "descricao": "OPERAÇÕES COM BENS DE ATIVO IMOBILIZADO E MATERIAIS PARA USO OU CONSUMO"
  },
  {
    "codigo": "3551",
    "descricao": "Compra de bem para o ativo imobilizado"
  },
  {
    "codigo": "3552",
    "descricao": "Entrada de produtos destinados ao uso ou consumo de bordo, em embarcações ou aeronaves exclusivamente em tráfego internacional com destino ao exterior"
  },
  {
    "codigo": "3553",
    "descricao": "Devolução de venda de bem do ativo imobilizado"
  },
  {
    "codigo": "3556",
    "descricao": "Compra de material para uso ou consumo"
  },
  {
    "codigo": "3650",
    "descricao": "ENTRADAS DE COMBUSTÍVEIS, DERIVADOS OU NÃO DE PETRÓLEO E LUBRIFICANTES"
  },
  {
    "codigo": "3651",
    "descricao": "Compra de combustível ou lubrificante para industrialização subseqüente"
  },
  {
    "codigo": "3652",
    "descricao": "Compra de combustível ou lubrificante para comercialização"
  },
  {
    "codigo": "3653",
    "descricao": "Compra de combustível ou lubrificante por consumidor ou usuário final"
  },
  {
    "codigo": "3667",
    "descricao": "Entrada de combustível ou lubrificante para consumo final, em embarcações ou aeronaves exclusivamente em tráfego internacional com destino ao exterior"
  },
  {
    "codigo": "3900",
    "descricao": "OUTRAS ENTRADAS DE MERCADORIAS OU AQUISIÇÕES DE SERVIÇOS"
  },
  {
    "codigo": "3930",
    "descricao": "Lançamento efetuado a título de entrada de bem sob amparo de regime especial aduaneiro de admissão temporária"
  },
  {
    "codigo": "3949",
    "descricao": "Outra entrada de mercadoria ou prestação de serviço não especificado"
  },
  {
    "codigo": "5000",
    "descricao": "SAÍDAS OU PRESTAÇÕES DE SERVIÇOS PARA O ESTADO"
  },
  {
    "codigo": "5100",
    "descricao": "VENDAS DE PRODUÇÃO PRÓPRIA OU DE TERCEIROS"
  },
  {
    "codigo": "5101",
    "descricao": "Venda de produção do estabelecimento"
  },
  {
    "codigo": "5102",
    "descricao": "Venda de mercadoria adquirida ou recebida de terceiros"
  },
  {
    "codigo": "5103",
    "descricao": "Venda de produção do estabelecimento, efetuada fora do estabelecimento"
  },
  {
    "codigo": "5104",
    "descricao": "Venda de mercadoria adquirida ou recebida de terceiros, efetuada fora do estabelecimento"
  },
  {
    "codigo": "5105",
    "descricao": "Venda de produção do estabelecimento que não deva por ele transitar"
  },
  {
    "codigo": "5106",
    "descricao": "Venda de mercadoria adquirida ou recebida de terceiros, que não deva por ele transitar"
  },
  {
    "codigo": "5109",
    "descricao": "Venda de produção do estabelecimento, destinada à Zona Franca de Manaus ou Áreas de Livre Comércio"
  },
  {
    "codigo": "5110",
    "descricao": "Venda de mercadoria adquirida ou recebida de terceiros, destinada à Zona Franca de Manaus ou Áreas de Livre Comércio"
  },
  {
    "codigo": "5111",
    "descricao": "Venda de produção do estabelecimento remetida anteriormente em consignação industrial"
  },
  {
    "codigo": "5112",
    "descricao": "Venda de mercadoria adquirida ou recebida de terceiros remetida anteriormente em consignação industrial"
  },
  {
    "codigo": "5113",
    "descricao": "Venda de produção do estabelecimento remetida anteriormente em consignação mercantil"
  },
  {
    "codigo": "5114",
    "descricao": "Venda de mercadoria adquirida ou recebida de terceiros remetida anteriormente em consignação mercantil"
  },
  {
    "codigo": "5115",
    "descricao": "Venda de mercadoria adquirida ou recebida de terceiros, recebida anteriormente em consignação mercantil"
  },
  {
    "codigo": "5116",
    "descricao": "Venda de produção do estabelecimento originada de encomenda para entrega futura"
  },
  {
    "codigo": "5117",
    "descricao": "Venda de mercadoria adquirida ou recebida de terceiros, originada de encomenda para entrega futura"
  },
  {
    "codigo": "5118",
    "descricao": "Venda de produção do estabelecimento entregue ao destinatário por conta e ordem do adquirente originário, em venda à ordem"
  },
  {
    "codigo": "5119",
    "descricao": "Venda de mercadoria adquirida ou recebida de terceiros entregue ao destinatário por conta e ordem do adquirente originário, em venda à ordem"
  },
  {
    "codigo": "5120",
    "descricao": "Venda de mercadoria adquirida ou recebida de terceiros entregue ao destinatário pelo vendedor remetente, em venda à ordem"
  },
  {
    "codigo": "5122",
    "descricao": "Venda de produção do estabelecimento remetida para industrialização, por conta e ordem do adquirente, sem transitar pelo estabelecimento do adquirente"
  },
  {
    "codigo": "5123",
    "descricao": "Venda de mercadoria adquirida ou recebida de terceiros remetida para industrialização, por conta e ordem do adquirente, sem transitar pelo estabelecimento do adquirente"
  },
  {
    "codigo": "5124",
    "descricao": "Industrialização efetuada para outra empresa"
  },
  {
    "codigo": "5125",
    "descricao": "Industrialização efetuada para outra empresa quando a mercadoria recebida para utilização no processo de industrialização não transitar pelo estabelecimento adquirente da mercadoria"
  },
  {
    "codigo": "5129",
    "descricao": "Venda de insumo importado e de mercadoria industrializada sob o amparo do Regime Aduaneiro Especial de Entreposto Industrial sob Controle Informatizado do Sistema Público de Escrituração Digital (Recof-Sped)."
  },
  {
    "codigo": "5131",
    "descricao": "Remessa de produção do estabelecimento, com previsão de posterior ajuste ou fixação de preço, de ato cooperativo."
  },
  {
    "codigo": "5132",
    "descricao": "Fixação de preço de produção do estabelecimento, inclusive quando remetidas anteriormente com previsão de posterior ajuste ou fixação de preço de ato cooperativo."
  },
  {
    "codigo": "5150",
    "descricao": "TRANSFERÊNCIAS DE PRODUÇÃO PRÓPRIA OU DE TERCEIROS"
  },
  {
    "codigo": "5151",
    "descricao": "Transferência de produção do estabelecimento"
  },
  {
    "codigo": "5152",
    "descricao": "Transferência de mercadoria adquirida ou recebida de terceiros"
  },
  {
    "codigo": "5153",
    "descricao": "Transferência de energia elétrica"
  },
  {
    "codigo": "5155",
    "descricao": "Transferência de produção do estabelecimento, que não deva por ele transitar"
  },
  {
    "codigo": "5156",
    "descricao": "Transferência de mercadoria adquirida ou recebida de terceiros, que não deva por ele transitar"
  },
  {
    "codigo": "5159",
    "descricao": "Fornecimento de produção do estabelecimento de ato cooperativo"
  },
  {
    "codigo": "5160",
    "descricao": "Fornecimento de mercadoria adquirida ou recebida de terceiros de ato cooperativo"
  },
  {
    "codigo": "5200",
    "descricao": "DEVOLUÇÕES DE COMPRAS PARA INDUSTRIALIZAÇÃO, PRODUÇÃO RURAL, COMERCIALIZAÇÃO OU ANULAÇÕES DE VALORES"
  },
  {
    "codigo": "5201",
    "descricao": "Devolução de compra para industrialização ou produção rural"
  },
  {
    "codigo": "5202",
    "descricao": "Devolução de compra para comercialização"
  },
  {
    "codigo": "5205",
    "descricao": "Anulação de valor relativo a aquisição de serviço de comunicação"
  },
  {
    "codigo": "5206",
    "descricao": "Anulação de valor relativo a aquisição de serviço de transporte"
  },
  {
    "codigo": "5207",
    "descricao": "Anulação de valor relativo à compra de energia elétrica"
  },
  {
    "codigo": "5208",
    "descricao": "Devolução de mercadoria recebida em transferência para industrialização ou produção rural"
  },
  {
    "codigo": "5209",
    "descricao": "Devolução de mercadoria recebida em transferência para comercialização"
  },
  {
    "codigo": "5210",
    "descricao": "Devolução de compra para utilização na prestação de serviço"
  },
  {
    "codigo": "5213",
    "descricao": "Devolução de entrada de mercadoria com previsão de posterior ajuste ou fixação de preço, em ato cooperativo."
  },
  {
    "codigo": "5214",
    "descricao": "Devolução de fixação de preço de produção do estabelecimento produtor, inclusive quando remetidas anteriormente com previsão de posterior ajuste ou fixação de preço, de ato cooperativo, para comercialização."
  },
  {
    "codigo": "5215",
    "descricao": "Devolução de fixação de preço de produção do estabelecimento produtor, inclusive quando remetidas anteriormente com previsão de posterior ajuste ou fixação de preço, de ato cooperativo, para industrialização."
  },
  {
    "codigo": "5216",
    "descricao": "Devolução de entrada decorrente do fornecimento de produto ou mercadoria de ato cooperativo"
  },
  {
    "codigo": "5250",
    "descricao": "VENDAS DE ENERGIA ELÉTRICA"
  },
  {
    "codigo": "5251",
    "descricao": "Venda de energia elétrica para distribuição ou comercialização"
  },
  {
    "codigo": "5252",
    "descricao": "Venda de energia elétrica para estabelecimento industrial"
  },
  {
    "codigo": "5253",
    "descricao": "Venda de energia elétrica para estabelecimento comercial"
  },
  {
    "codigo": "5254",
    "descricao": "Venda de energia elétrica para estabelecimento prestador de serviço de transporte"
  },
  {
    "codigo": "5255",
    "descricao": "Venda de energia elétrica para estabelecimento prestador de serviço de comunicação"
  },
  {
    "codigo": "5256",
    "descricao": "Venda de energia elétrica para estabelecimento de produtor rural"
  },
  {
    "codigo": "5257",
    "descricao": "Venda de energia elétrica para consumo por demanda contratada"
  },
  {
    "codigo": "5258",
    "descricao": "Venda de energia elétrica a não contribuinte"
  },
  {
    "codigo": "5300",
    "descricao": "PRESTAÇÕES DE SERVIÇOS DE COMUNICAÇÃO"
  },
  {
    "codigo": "5301",
    "descricao": "Prestação de serviço de comunicação para execução de serviço da mesma natureza"
  },
  {
    "codigo": "5302",
    "descricao": "Prestação de serviço de comunicação a estabelecimento industrial"
  },
  {
    "codigo": "5303",
    "descricao": "Prestação de serviço de comunicação a estabelecimento comercial"
  },
  {
    "codigo": "5304",
    "descricao": "Prestação de serviço de comunicação a estabelecimento de prestador de serviço de transporte"
  },
  {
    "codigo": "5305",
    "descricao": "Prestação de serviço de comunicação a estabelecimento de geradora ou de distribuidora de energia elétrica"
  },
  {
    "codigo": "5306",
    "descricao": "Prestação de serviço de comunicação a estabelecimento de produtor rural"
  },
  {
    "codigo": "5307",
    "descricao": "Prestação de serviço de comunicação a não contribuinte"
  },
  {
    "codigo": "5350",
    "descricao": "PRESTAÇÕES DE SERVIÇOS DE TRANSPORTE"
  },
  {
    "codigo": "5351",
    "descricao": "Prestação de serviço de transporte para execução de serviço da mesma natureza"
  },
  {
    "codigo": "5352",
    "descricao": "Prestação de serviço de transporte a estabelecimento industrial"
  },
  {
    "codigo": "5353",
    "descricao": "Prestação de serviço de transporte a estabelecimento comercial"
  },
  {
    "codigo": "5354",
    "descricao": "Prestação de serviço de transporte a estabelecimento de prestador de serviço de comunicação"
  },
  {
    "codigo": "5355",
    "descricao": "Prestação de serviço de transporte a estabelecimento de geradora ou de distribuidora de energia elétrica"
  },
  {
    "codigo": "5356",
    "descricao": "Prestação de serviço de transporte a estabelecimento de produtor rural"
  },
  {
    "codigo": "5357",
    "descricao": "Prestação de serviço de transporte a não contribuinte"
  },
  {
    "codigo": "5359",
    "descricao": "Prestação de serviço de transporte a contribuinte ou a não contribuinte quando a mercadoria transportada está dispensada de emissão de nota fiscal."
  },
  {
    "codigo": "5360",
    "descricao": "Prestação de serviço de transporte a contribuinte substituto em relação ao serviço de transporte"
  },
  {
    "codigo": "5400",
    "descricao": "SAÍDAS DE MERCADORIAS SUJEITAS AO REGIME DE SUBSTITUIÇÃO TRIBUTÁRIA"
  },
  {
    "codigo": "5401",
    "descricao": "Venda de produção do estabelecimento em operação com produto sujeito ao regime de substituição tributária, na condição de contribuinte substituto"
  },
  {
    "codigo": "5402",
    "descricao": "Venda de produção do estabelecimento de produto sujeito ao regime de substituição tributária, em operação entre contribuintes substitutos do mesmo produto"
  },
  {
    "codigo": "5403",
    "descricao": "Venda de mercadoria adquirida ou recebida de terceiros em operação com mercadoria sujeita ao regime de substituição tributária, na condição de contribuinte substituto"
  },
  {
    "codigo": "5405",
    "descricao": "Venda de mercadoria adquirida ou recebida de terceiros em operação com mercadoria sujeita ao regime de substituição tributária, na condição de contribuinte substituído"
  },
  {
    "codigo": "5408",
    "descricao": "Transferência de produção do estabelecimento em operação com produto sujeito ao regime de substituição tributária"
  },
  {
    "codigo": "5409",
    "descricao": "Transferência de mercadoria adquirida ou recebida de terceiros em operação com mercadoria sujeita ao regime de substituição tributária"
  },
  {
    "codigo": "5410",
    "descricao": "Devolução de compra para industrialização ou produção rural em operação com mercadoria sujeita ao regime de substituição tributária"
  },
  {
    "codigo": "5411",
    "descricao": "Devolução de compra para comercialização em operação com mercadoria sujeita ao regime de substituição tributária"
  },
  {
    "codigo": "5412",
    "descricao": "Devolução de bem do ativo imobilizado, em operação com mercadoria sujeita ao regime de substituição tributária"
  },
  {
    "codigo": "5413",
    "descricao": "Devolução de mercadoria destinada ao uso ou consumo, em operação com mercadoria sujeita ao regime de substituição tributária"
  },
  {
    "codigo": "5414",
    "descricao": "Remessa de produção do estabelecimento para venda fora do estabelecimento em operação com produto sujeito ao regime de substituição tributária"
  },
  {
    "codigo": "5415",
    "descricao": "Remessa de mercadoria adquirida ou recebida de terceiros para venda fora do estabelecimento, em operação com mercadoria sujeita ao regime de substituição tributária"
  },
  {
    "codigo": "5450",
    "descricao": "SISTEMAS DE INTEGRAÇÃO E PARCERIA RURAL"
  },
  {
    "codigo": "5451",
    "descricao": "Remessa de animal - Sistema de Integração e Parceria Rural"
  },
  {
    "codigo": "5452",
    "descricao": "Remessa de insumo - Sistema de Integração e Parceria Rural"
  },
  {
    "codigo": "5453",
    "descricao": "Retorno de animal ou da produção - Sistema de Integração e Parceria Rural"
  },
  {
    "codigo": "5454",
    "descricao": "Retorno simbólico de animal ou da produção - Sistema de Integração e Parceria Rural"
  },
  {
    "codigo": "5455",
    "descricao": "Retorno de insumos não utilizados na produção - Sistema de Integração e Parceria Rural"
  },
  {
    "codigo": "5456",
    "descricao": "Saída referente a remuneração do produtor - Sistema de Integração e Parceria Rural"
  },
  {
    "codigo": "5500",
    "descricao": "REMESSAS COM FIM ESPECÍFICO DE EXPORTAÇÃO E EVENTUAIS DEVOLUÇÕES"
  },
  {
    "codigo": "5501",
    "descricao": "Remessa de produção do estabelecimento, com fim específico de exportação"
  },
  {
    "codigo": "5502",
    "descricao": "Remessa de mercadoria adquirida ou recebida de terceiros, com fim específico de exportação"
  },
  {
    "codigo": "5503",
    "descricao": "Devolução de mercadoria recebida com fim específico de exportação"
  },
  {
    "codigo": "5550",
    "descricao": "OPERAÇÕES COM BENS DE ATIVO IMOBILIZADO E MATERIAIS PARA USO OU CONSUMO"
  },
  {
    "codigo": "5551",
    "descricao": "Venda de bem do ativo imobilizado"
  },
  {
    "codigo": "5552",
    "descricao": "Transferência de bem do ativo imobilizado"
  },
  {
    "codigo": "5553",
    "descricao": "Devolução de compra de bem para o ativo imobilizado"
  },
  {
    "codigo": "5554",
    "descricao": "Remessa de bem do ativo imobilizado para uso fora do estabelecimento"
  },
  {
    "codigo": "5555",
    "descricao": "Devolução de bem do ativo imobilizado de terceiro, recebido para uso no estabelecimento"
  },
  {
    "codigo": "5556",
    "descricao": "Devolução de compra de material de uso ou consumo"
  },
  {
    "codigo": "5557",
    "descricao": "Transferência de material de uso ou consumo"
  },
  {
    "codigo": "5600",
    "descricao": "CRÉDITOS E RESSARCIMENTOS DE ICMS"
  },
  {
    "codigo": "5601",
    "descricao": "Transferência de crédito de ICMS acumulado"
  },
  {
    "codigo": "5602",
    "descricao": "Transferência de saldo credor de ICMS para outro estabelecimento da mesma empresa, destinado à compensação de saldo devedor de ICMS"
  },
  {
    "codigo": "5603",
    "descricao": "Ressarcimento de ICMS retido por substituição tributária"
  },
  {
    "codigo": "5605",
    "descricao": "Transferência de saldo devedor de ICMS de outro estabelecimento da mesma empresa."
  },
  {
    "codigo": "5606",
    "descricao": "Utilização de saldo credor de ICMS para extinção por compensação de débitos fiscais."
  },
  {
    "codigo": "5650",
    "descricao": "SAÍDAS DE COMBUSTÍVEIS, DERIVADOS OU NÃO DE PETRÓLEO E LUBRIFICANTES"
  },
  {
    "codigo": "5651",
    "descricao": "Venda de combustível ou lubrificante de produção do estabelecimento destinado à industrialização subseqüente"
  },
  {
    "codigo": "5652",
    "descricao": "Venda de combustível ou lubrificante de produção do estabelecimento destinado à comercialização"
  },
  {
    "codigo": "5653",
    "descricao": "Venda de combustível ou lubrificante de produção do estabelecimento destinado a consumidor ou usuário final"
  },
  {
    "codigo": "5654",
    "descricao": "Venda de combustível ou lubrificante adquirido ou recebido de terceiros destinado à industrialização subseqüente"
  },
  {
    "codigo": "5655",
    "descricao": "Venda de combustível ou lubrificante adquirido ou recebido de terceiros destinado à comercialização"
  },
  {
    "codigo": "5656",
    "descricao": "Venda de combustível ou lubrificante adquirido ou recebido de terceiros destinado a consumidor ou usuário final"
  },
  {
    "codigo": "5657",
    "descricao": "Remessa de combustível ou lubrificante adquirido ou recebido de terceiros para venda fora do estabelecimento"
  },
  {
    "codigo": "5658",
    "descricao": "Transferência de combustível ou lubrificante de produção do estabelecimento"
  },
  {
    "codigo": "5659",
    "descricao": "Transferência de combustível ou lubrificante adquirido ou recebido de terceiro"
  },
  {
    "codigo": "5660",
    "descricao": "Devolução de compra de combustível ou lubrificante adquirido para industrialização subseqüente"
  },
  {
    "codigo": "5661",
    "descricao": "Devolução de compra de combustível ou lubrificante adquirido para comercialização"
  },
  {
    "codigo": "5662",
    "descricao": "Devolução de compra de combustível ou lubrificante adquirido por consumidor ou usuário final"
  },
  {
    "codigo": "5663",
    "descricao": "Remessa para armazenagem de combustível ou lubrificante"
  },
  {
    "codigo": "5664",
    "descricao": "Retorno de combustível ou lubrificante recebido para armazenagem"
  },
  {
    "codigo": "5665",
    "descricao": "Retorno simbólico de combustível ou lubrificante recebido para armazenagem"
  },
  {
    "codigo": "5666",
    "descricao": "Remessa por conta e ordem de terceiros de combustível ou lubrificante recebido para armazenagem"
  },
  {
    "codigo": "5667",
    "descricao": "Venda de combustível ou lubrificante a consumidor ou usuário final estabelecido em outra unidade da Federação"
  },
  {
    "codigo": "5900",
    "descricao": "OUTRAS SAÍDAS DE MERCADORIAS OU PRESTAÇÕES DE SERVIÇOS"
  },
  {
    "codigo": "5901",
    "descricao": "Remessa para industrialização por encomenda"
  },
  {
    "codigo": "5902",
    "descricao": "Retorno de mercadoria utilizada na industrialização por encomenda"
  },
  {
    "codigo": "5903",
    "descricao": "Retorno de mercadoria recebida para industrialização e não aplicada no referido processo"
  },
  {
    "codigo": "5904",
    "descricao": "Remessa para venda fora do estabelecimento"
  },
  {
    "codigo": "5905",
    "descricao": "Remessa para depósito fechado ou armazém geral"
  },
  {
    "codigo": "5906",
    "descricao": "Retorno de mercadoria depositada em depósito fechado ou armazém geral"
  },
  {
    "codigo": "5907",
    "descricao": "Retorno simbólico de mercadoria depositada em depósito fechado ou armazém geral"
  },
  {
    "codigo": "5908",
    "descricao": "Remessa de bem por conta de contrato de comodato ou locação"
  },
  {
    "codigo": "5909",
    "descricao": "Retorno de bem recebido por conta de contrato de comodato ou locação"
  },
  {
    "codigo": "5910",
    "descricao": "Remessa em bonificação, doação ou brinde"
  },
  {
    "codigo": "5911",
    "descricao": "Remessa de amostra grátis"
  },
  {
    "codigo": "5912",
    "descricao": "Remessa de mercadoria ou bem para demonstração"
  },
  {
    "codigo": "5913",
    "descricao": "Retorno de mercadoria ou bem recebido para demonstração"
  },
  {
    "codigo": "5914",
    "descricao": "Remessa de mercadoria ou bem para exposição ou feira"
  },
  {
    "codigo": "5915",
    "descricao": "Remessa de mercadoria ou bem para conserto ou reparo"
  },
  {
    "codigo": "5916",
    "descricao": "Retorno de mercadoria ou bem recebido para conserto ou reparo"
  },
  {
    "codigo": "5917",
    "descricao": "Remessa de mercadoria em consignação mercantil ou industrial"
  },
  {
    "codigo": "5918",
    "descricao": "Devolução de mercadoria recebida em consignação mercantil ou industrial"
  },
  {
    "codigo": "5919",
    "descricao": "Devolução simbólica de mercadoria vendida ou utilizada em processo industrial, recebida anteriormente em consignação mercantil ou industrial"
  },
  {
    "codigo": "5920",
    "descricao": "Remessa de vasilhame ou sacaria"
  },
  {
    "codigo": "5921",
    "descricao": "Devolução de vasilhame ou sacaria"
  },
  {
    "codigo": "5922",
    "descricao": "Lançamento efetuado a título de simples faturamento decorrente de venda para entrega futura"
  },
  {
    "codigo": "5923",
    "descricao": "Remessa de mercadoria por conta e ordem de terceiros, em venda à ordem ou em operações com armazém geral ou depósito fechado."
  },
  {
    "codigo": "5924",
    "descricao": "Remessa para industrialização por conta e ordem do adquirente da mercadoria, quando esta não transitar pelo estabelecimento do adquirente"
  },
  {
    "codigo": "5925",
    "descricao": "Retorno de mercadoria recebida para industrialização por conta e ordem do adquirente da mercadoria, quando aquela não transitar pelo estabelecimento do adquirente"
  },
  {
    "codigo": "5926",
    "descricao": "Lançamento efetuado a título de reclassificação de mercadoria decorrente de formação de kit ou de sua desagregação"
  },
  {
    "codigo": "5927",
    "descricao": "Lançamento efetuado a título de baixa de estoque decorrente de perda, roubo ou deterioração"
  },
  {
    "codigo": "5928",
    "descricao": "Lançamento efetuado a título de baixa de estoque decorrente do encerramento da atividade da empresa"
  },
  {
    "codigo": "5929",
    "descricao": "Lançamento efetuado em decorrência de emissão de documento fiscal relativo a operação ou prestação também acobertada por documento fiscal do varejo."
  },
  {
    "codigo": "5931",
    "descricao": "Lançamento efetuado em decorrência da responsabilidade de retenção do imposto por substituição tributária, atribuída ao remetente ou alienante da mercadoria, pelo serviço de transporte realizado por transportador autônomo ou por transportador não inscrito na unidade da Federação onde iniciado o serviço"
  },
  {
    "codigo": "5932",
    "descricao": "Prestação de serviço de transporte iniciada em unidade da Federação diversa daquela onde inscrito o prestador"
  },
  {
    "codigo": "5933",
    "descricao": "Prestação de serviço tributado pelo ISSQN"
  },
  {
    "codigo": "5934",
    "descricao": "Remessa simbólica de mercadoria depositada em armazém geral ou depósito fechado"
  },
  {
    "codigo": "5949",
    "descricao": "Outra saída de mercadoria ou prestação de serviço não especificado"
  },
  {
    "codigo": "6000",
    "descricao": "SAÍDAS OU PRESTAÇÕES DE SERVIÇOS PARA OUTROS ESTADOS"
  },
  {
    "codigo": "6100",
    "descricao": "VENDAS DE PRODUÇÃO PRÓPRIA OU DE TERCEIROS"
  },
  {
    "codigo": "6101",
    "descricao": "Venda de produção do estabelecimento"
  },
  {
    "codigo": "6102",
    "descricao": "Venda de mercadoria adquirida ou recebida de terceiros"
  },
  {
    "codigo": "6103",
    "descricao": "Venda de produção do estabelecimento, efetuada fora do estabelecimento"
  },
  {
    "codigo": "6104",
    "descricao": "Venda de mercadoria adquirida ou recebida de terceiros, efetuada fora do estabelecimento"
  },
  {
    "codigo": "6105",
    "descricao": "Venda de produção do estabelecimento que não deva por ele transitar"
  },
  {
    "codigo": "6106",
    "descricao": "Venda de mercadoria adquirida ou recebida de terceiros, que não deva por ele transitar"
  },
  {
    "codigo": "6107",
    "descricao": "Venda de produção do estabelecimento, destinada a não contribuinte"
  },
  {
    "codigo": "6108",
    "descricao": "Venda de mercadoria adquirida ou recebida de terceiros, destinada a não contribuinte"
  },
  {
    "codigo": "6109",
    "descricao": "Venda de produção do estabelecimento, destinada à Zona Franca de Manaus ou Áreas de Livre Comércio"
  },
  {
    "codigo": "6110",
    "descricao": "Venda de mercadoria adquirida ou recebida de terceiros, destinada à Zona Franca de Manaus ou Áreas de Livre Comércio"
  },
  {
    "codigo": "6111",
    "descricao": "Venda de produção do estabelecimento remetida anteriormente em consignação industrial"
  },
  {
    "codigo": "6112",
    "descricao": "Venda de mercadoria adquirida ou recebida de Terceiros remetida anteriormente em consignação industrial"
  },
  {
    "codigo": "6113",
    "descricao": "Venda de produção do estabelecimento remetida anteriormente em consignação mercantil"
  },
  {
    "codigo": "6114",
    "descricao": "Venda de mercadoria adquirida ou recebida de terceiros remetida anteriormente em consignação mercantil"
  },
  {
    "codigo": "6115",
    "descricao": "Venda de mercadoria adquirida ou recebida de terceiros, recebida anteriormente em consignação mercantil"
  },
  {
    "codigo": "6116",
    "descricao": "Venda de produção do estabelecimento originada de encomenda para entrega futura"
  },
  {
    "codigo": "6117",
    "descricao": "Venda de mercadoria adquirida ou recebida de terceiros, originada de encomenda para entrega futura"
  },
  {
    "codigo": "6118",
    "descricao": "Venda de produção do estabelecimento entregue ao destinatário por conta e ordem do adquirente originário, em venda à ordem"
  },
  {
    "codigo": "6119",
    "descricao": "Venda de mercadoria adquirida ou recebida de terceiros entregue ao destinatário por conta e ordem do adquirente originário, em venda à ordem"
  },
  {
    "codigo": "6120",
    "descricao": "Venda de mercadoria adquirida ou recebida de terceiros entregue ao destinatário pelo vendedor remetente, em venda à ordem"
  },
  {
    "codigo": "6122",
    "descricao": "Venda de produção do estabelecimento remetida para industrialização, por conta e ordem do adquirente, sem transitar pelo estabelecimento do adquirente"
  },
  {
    "codigo": "6123",
    "descricao": "Venda de mercadoria adquirida ou recebida de terceiros remetida para industrialização, por conta e ordem do adquirente, sem transitar pelo estabelecimento do adquirente"
  },
  {
    "codigo": "6124",
    "descricao": "Industrialização efetuada para outra empresa"
  },
  {
    "codigo": "6125",
    "descricao": "Industrialização efetuada para outra empresa quando a mercadoria recebida para utilização no processo de industrialização não transitar pelo estabelecimento adquirente da mercadoria"
  },
  {
    "codigo": "6129",
    "descricao": "Venda de insumo importado e de mercadoria industrializada sob o amparo do Regime Aduaneiro Especial de Entreposto Industrial sob Controle Informatizado do Sistema Público de Escrituração Digital (Recof-Sped)."
  },
  {
    "codigo": "6131",
    "descricao": "Remessa de produção de estabelecimento, com previsão de posterior ajuste ou fixação de preço de ato cooperativo."
  },
  {
    "codigo": "6132",
    "descricao": "Fixação de preço de produção do estabelecimento, inclusive quando remetidas anteriormente com previsão de posterior ajuste ou fixação de preço ou fixação de preço de ato cooperativo."
  },
  {
    "codigo": "6150",
    "descricao": "TRANSFERÊNCIAS DE PRODUÇÃO PRÓPRIA OU DE TERCEIROS"
  },
  {
    "codigo": "6151",
    "descricao": "Transferência de produção do estabelecimento"
  },
  {
    "codigo": "6152",
    "descricao": "Transferência de mercadoria adquirida ou recebida de terceiros"
  },
  {
    "codigo": "6153",
    "descricao": "Transferência de energia elétrica"
  },
  {
    "codigo": "6155",
    "descricao": "Transferência de produção do estabelecimento, que não deva por ele transitar"
  },
  {
    "codigo": "6156",
    "descricao": "Transferência de mercadoria adquirida ou recebida de terceiros, que não deva por ele transitar"
  },
  {
    "codigo": "6159",
    "descricao": "Fornecimento de produção do estabelecimento de ato cooperativo"
  },
  {
    "codigo": "6160",
    "descricao": "Fornecimento de mercadoria adquirida ou recebida de terceiros de ato cooperativo"
  },
  {
    "codigo": "6200",
    "descricao": "DEVOLUÇÕES DE COMPRAS PARA INDUSTRIALIZAÇÃO, PRODUÇÃO RURAL, COMERCIALIZAÇÃO OU ANULAÇÕES DE VALORES"
  },
  {
    "codigo": "6201",
    "descricao": "Devolução de compra para industrialização ou produção rural"
  },
  {
    "codigo": "6202",
    "descricao": "Devolução de compra para comercialização"
  },
  {
    "codigo": "6205",
    "descricao": "Anulação de valor relativo a aquisição de serviço de comunicação"
  },
  {
    "codigo": "6206",
    "descricao": "Anulação de valor relativo a aquisição de serviço de transporte"
  },
  {
    "codigo": "6207",
    "descricao": "Anulação de valor relativo à compra de energia elétrica"
  },
  {
    "codigo": "6208",
    "descricao": "Devolução de mercadoria recebida em transferência para industrialização ou produção rural"
  },
  {
    "codigo": "6209",
    "descricao": "Devolução de mercadoria recebida em transferência para comercialização"
  },
  {
    "codigo": "6210",
    "descricao": "Devolução de compra para utilização na prestação de serviço"
  },
  {
    "codigo": "6213",
    "descricao": "Devolução de entrada de mercadoria com previsão de posterior ajuste ou fixação de preço, em ato cooperativo."
  },
  {
    "codigo": "6214",
    "descricao": "Devolução de fixação de preço de produção do estabelecimento produtor, inclusive quando remetidas anteriormente com previsão de posterior ajuste ou fixação de preço, de ato cooperativo, para comercialização."
  },
  {
    "codigo": "6215",
    "descricao": "Devolução de fixação de preço de produção do estabelecimento produtor, inclusive quando remetidas anteriormente com previsão de posterior ajuste ou fixação de preço, de ato cooperativo para industrialização."
  },
  {
    "codigo": "6216",
    "descricao": "Devolução de entrada decorrente do fornecimento de produto ou mercadoria de ato cooperativo"
  },
  {
    "codigo": "6250",
    "descricao": "VENDAS DE ENERGIA ELÉTRICA"
  },
  {
    "codigo": "6251",
    "descricao": "Venda de energia elétrica para distribuição ou comercialização"
  },
  {
    "codigo": "6252",
    "descricao": "Venda de energia elétrica para estabelecimento industrial"
  },
  {
    "codigo": "6253",
    "descricao": "Venda de energia elétrica para estabelecimento comercial"
  },
  {
    "codigo": "6254",
    "descricao": "Venda de energia elétrica para estabelecimento prestador de serviço de transporte"
  },
  {
    "codigo": "6255",
    "descricao": "Venda de energia elétrica para estabelecimento prestador de serviço de comunicação"
  },
  {
    "codigo": "6256",
    "descricao": "Venda de energia elétrica para estabelecimento de produtor rural"
  },
  {
    "codigo": "6257",
    "descricao": "Venda de energia elétrica para consumo por demanda contratada"
  },
  {
    "codigo": "6258",
    "descricao": "Venda de energia elétrica a não contribuinte"
  },
  {
    "codigo": "6300",
    "descricao": "PRESTAÇÕES DE SERVIÇOS DE COMUNICAÇÃO"
  },
  {
    "codigo": "6301",
    "descricao": "Prestação de serviço de comunicação para execução de serviço da mesma natureza"
  },
  {
    "codigo": "6302",
    "descricao": "Prestação de serviço de comunicação a estabelecimento industrial"
  },
  {
    "codigo": "6303",
    "descricao": "Prestação de serviço de comunicação a estabelecimento comercial"
  },
  {
    "codigo": "6304",
    "descricao": "Prestação de serviço de comunicação a estabelecimento de prestador de serviço de transporte"
  },
  {
    "codigo": "6305",
    "descricao": "Prestação de serviço de comunicação a estabelecimento de geradora ou de distribuidora de energia elétrica"
  },
  {
    "codigo": "6306",
    "descricao": "Prestação de serviço de comunicação a estabelecimento de produtor rural"
  },
  {
    "codigo": "6307",
    "descricao": "Prestação de serviço de comunicação a não contribuinte"
  },
  {
    "codigo": "6350",
    "descricao": "PRESTAÇÕES DE SERVIÇOS DE TRANSPORTE"
  },
  {
    "codigo": "6351",
    "descricao": "Prestação de serviço de transporte para execução de serviço da mesma natureza"
  },
  {
    "codigo": "6352",
    "descricao": "Prestação de serviço de transporte a estabelecimento industrial"
  },
  {
    "codigo": "6353",
    "descricao": "Prestação de serviço de transporte a estabelecimento comercial"
  },
  {
    "codigo": "6354",
    "descricao": "Prestação de serviço de transporte a estabelecimento de prestador de serviço de comunicação"
  },
  {
    "codigo": "6355",
    "descricao": "Prestação de serviço de transporte a estabelecimento de geradora ou de distribuidora de energia elétrica"
  },
  {
    "codigo": "6356",
    "descricao": "Prestação de serviço de transporte a estabelecimento de produtor rural"
  },
  {
    "codigo": "6357",
    "descricao": "Prestação de serviço de transporte a não contribuinte"
  },
  {
    "codigo": "6359",
    "descricao": "Prestação de serviço de transporte a contribuinte ou a não contribuinte quando a mercadoria transportada está dispensada de emissão de nota fiscal."
  },
  {
    "codigo": "6360",
    "descricao": "Prestação de serviço de transporte a contribuinte substituto em relação ao serviço de transporte."
  },
  {
    "codigo": "6400",
    "descricao": "SAÍDAS DE MERCADORIAS SUJEITAS AO REGIME DE SUBSTITUIÇÃO TRIBUTÁRIA"
  },
  {
    "codigo": "6401",
    "descricao": "Venda de produção do estabelecimento em operação com produto sujeito ao regime de substituição tributária, na condição de contribuinte substituto"
  },
  {
    "codigo": "6402",
    "descricao": "Venda de produção do estabelecimento de produto sujeito ao regime de substituição tributária, em operação entre contribuintes substitutos do mesmo produto"
  },
  {
    "codigo": "6403",
    "descricao": "Venda de mercadoria adquirida ou recebida de terceiros em operação com mercadoria sujeita ao regime de substituição tributária, na condição de contribuinte substituto"
  },
  {
    "codigo": "6404",
    "descricao": "Venda de mercadoria sujeita ao regime de substituição tributária, cujo imposto já tenha sido retido anteriormente"
  },
  {
    "codigo": "6408",
    "descricao": "Transferência de produção do estabelecimento em operação com produto sujeito ao regime de substituição tributária"
  },
  {
    "codigo": "6409",
    "descricao": "Transferência de mercadoria adquirida ou recebida de terceiros em operação com mercadoria sujeita ao regime de substituição tributária"
  },
  {
    "codigo": "6410",
    "descricao": "Devolução de compra para industrialização ou produção rural em operação com mercadoria sujeita ao regime de substituição tributária"
  },
  {
    "codigo": "6411",
    "descricao": "Devolução de compra para comercialização em operação com mercadoria sujeita ao regime de substituição tributária"
  },
  {
    "codigo": "6412",
    "descricao": "Devolução de bem do ativo imobilizado, em operação com mercadoria sujeita ao regime de substituição tributária"
  },
  {
    "codigo": "6413",
    "descricao": "Devolução de mercadoria destinada ao uso ou consumo, em operação com mercadoria sujeita ao regime de substituição tributária"
  },
  {
    "codigo": "6414",
    "descricao": "Remessa de produção do estabelecimento para venda fora do estabelecimento em operação com produto sujeito ao regime de substituição tributária"
  },
  {
    "codigo": "6415",
    "descricao": "Remessa de mercadoria adquirida ou recebida de terceiros para venda fora do estabelecimento, em operação com mercadoria sujeita ao regime de substituição tributária"
  },
  {
    "codigo": "6450",
    "descricao": "SISTEMAS DE INTEGRAÇÃO E PARCERIA RURAL"
  },
  {
    "codigo": "6451",
    "descricao": "Remessa de animal - Sistema de Integração e Parceria Rural"
  },
  {
    "codigo": "6452",
    "descricao": "Remessa de insumo - Sistema de Integração e Parceria Rural"
  },
  {
    "codigo": "6453",
    "descricao": "Retorno de animal ou da produção - Sistema de Integração e Parceria Rural"
  },
  {
    "codigo": "6454",
    "descricao": "Retorno simbólico de animal ou da produção - Sistema de Integração e Parceria Rural"
  },
  {
    "codigo": "6455",
    "descricao": "Retorno de insumos não utilizados na produção - Sistema de Integração e Parceria Rural"
  },
  {
    "codigo": "6456",
    "descricao": "Saída referente a remuneração do produtor - Sistema de Integração e Parceria Rural"
  },
  {
    "codigo": "6500",
    "descricao": "REMESSAS COM FIM ESPECÍFICO DE EXPORTAÇÃO E EVENTUAIS DEVOLUÇÕES"
  },
  {
    "codigo": "6501",
    "descricao": "Remessa de produção do estabelecimento, com fim específico de exportação"
  },
  {
    "codigo": "6502",
    "descricao": "Remessa de mercadoria adquirida ou recebida de terceiros, com fim específico de exportação"
  },
  {
    "codigo": "6503",
    "descricao": "Devolução de mercadoria recebida com fim específico de exportação"
  },
  {
    "codigo": "6550",
    "descricao": "OPERAÇÕES COM BENS DE ATIVO IMOBILIZADO E MATERIAIS PARA USO OU CONSUMO"
  },
  {
    "codigo": "6551",
    "descricao": "Venda de bem do ativo imobilizado"
  },
  {
    "codigo": "6552",
    "descricao": "Transferência de bem do ativo imobilizado"
  },
  {
    "codigo": "6553",
    "descricao": "Devolução de compra de bem para o ativo imobilizado"
  },
  {
    "codigo": "6554",
    "descricao": "Remessa de bem do ativo imobilizado para uso fora do estabelecimento"
  },
  {
    "codigo": "6555",
    "descricao": "Devolução de bem do ativo imobilizado de terceiro, recebido para uso no estabelecimento"
  },
  {
    "codigo": "6556",
    "descricao": "Devolução de compra de material de uso ou consumo"
  },
  {
    "codigo": "6557",
    "descricao": "Transferência de material de uso ou consumo"
  },
  {
    "codigo": "6600",
    "descricao": "CRÉDITOS E RESSARCIMENTOS DE ICMS"
  },
  {
    "codigo": "6603",
    "descricao": "Ressarcimento de ICMS retido por substituição tributária"
  },
  {
    "codigo": "6650",
    "descricao": "SAÍDAS DE COMBUSTÍVEIS, DERIVADOS OU NÃO DE PETRÓLEO E LUBRIFICANTES"
  },
  {
    "codigo": "6651",
    "descricao": "Venda de combustível ou lubrificante de produção do estabelecimento destinado à industrialização subseqüente"
  },
  {
    "codigo": "6652",
    "descricao": "Venda de combustível ou lubrificante de produção do estabelecimento destinado à comercialização"
  },
  {
    "codigo": "6653",
    "descricao": "Venda de combustível ou lubrificante de produção do estabelecimento destinado a consumidor ou usuário final"
  },
  {
    "codigo": "6654",
    "descricao": "Venda de combustível ou lubrificante adquirido ou recebido de terceiros destinado à industrialização subseqüente"
  },
  {
    "codigo": "6655",
    "descricao": "Venda de combustível ou lubrificante adquirido ou recebido de terceiros destinado à comercialização"
  },
  {
    "codigo": "6656",
    "descricao": "Venda de combustível ou lubrificante adquirido ou recebido de terceiros destinado a consumidor ou usuário final"
  },
  {
    "codigo": "6657",
    "descricao": "Remessa de combustível ou lubrificante adquirido ou recebido de terceiros para venda fora do estabelecimento"
  },
  {
    "codigo": "6658",
    "descricao": "Transferência de combustível ou lubrificante de produção do estabelecimento"
  },
  {
    "codigo": "6659",
    "descricao": "Transferência de combustível ou lubrificante adquirido ou recebido de terceiro"
  },
  {
    "codigo": "6660",
    "descricao": "Devolução de compra de combustível ou lubrificante adquirido para industrialização subseqüente"
  },
  {
    "codigo": "6661",
    "descricao": "Devolução de compra de combustível ou lubrificante adquirido para comercialização"
  },
  {
    "codigo": "6662",
    "descricao": "Devolução de compra de combustível ou lubrificante adquirido por consumidor ou usuário final"
  },
  {
    "codigo": "6663",
    "descricao": "Remessa para armazenagem de combustível ou lubrificante"
  },
  {
    "codigo": "6664",
    "descricao": "Retorno de combustível ou lubrificante recebido para armazenagem"
  },
  {
    "codigo": "6665",
    "descricao": "Retorno simbólico de combustível ou lubrificante recebido para armazenagem"
  },
  {
    "codigo": "6666",
    "descricao": "Remessa por conta e ordem de terceiros de combustível ou lubrificante recebido para armazenagem"
  },
  {
    "codigo": "6667",
    "descricao": "Venda de combustível ou lubrificante a consumidor ou usuário final estabelecido em outra unidade da Federação diferente da que ocorrer o consumo"
  },
  {
    "codigo": "6900",
    "descricao": "OUTRAS SAÍDAS DE MERCADORIAS OU PRESTAÇÕES DE SERVIÇOS"
  },
  {
    "codigo": "6901",
    "descricao": "Remessa para industrialização por encomenda"
  },
  {
    "codigo": "6902",
    "descricao": "Retorno de mercadoria utilizada na industrialização por encomenda"
  },
  {
    "codigo": "6903",
    "descricao": "Retorno de mercadoria recebida para industrialização e não aplicada no referido processo"
  },
  {
    "codigo": "6904",
    "descricao": "Remessa para venda fora do estabelecimento"
  },
  {
    "codigo": "6905",
    "descricao": "Remessa para depósito fechado ou armazém geral"
  },
  {
    "codigo": "6906",
    "descricao": "Retorno de mercadoria depositada em depósito fechado ou armazém geral"
  },
  {
    "codigo": "6907",
    "descricao": "Retorno simbólico de mercadoria depositada em depósito fechado ou armazém geral"
  },
  {
    "codigo": "6908",
    "descricao": "Remessa de bem por conta de contrato de comodato ou locação"
  },
  {
    "codigo": "6909",
    "descricao": "Retorno de bem recebido por conta de contrato de comodato ou locação"
  },
  {
    "codigo": "6910",
    "descricao": "Remessa em bonificação, doação ou brinde"
  },
  {
    "codigo": "6911",
    "descricao": "Remessa de amostra grátis"
  },
  {
    "codigo": "6912",
    "descricao": "Remessa de mercadoria ou bem para demonstração"
  },
  {
    "codigo": "6913",
    "descricao": "Retorno de mercadoria ou bem recebido para demonstração"
  },
  {
    "codigo": "6914",
    "descricao": "Remessa de mercadoria ou bem para exposição ou feira"
  },
  {
    "codigo": "6915",
    "descricao": "Remessa de mercadoria ou bem para conserto ou reparo"
  },
  {
    "codigo": "6916",
    "descricao": "Retorno de mercadoria ou bem recebido para conserto ou reparo"
  },
  {
    "codigo": "6917",
    "descricao": "Remessa de mercadoria em consignação mercantil ou industrial"
  },
  {
    "codigo": "6918",
    "descricao": "Devolução de mercadoria recebida em consignação mercantil ou industrial"
  },
  {
    "codigo": "6919",
    "descricao": "Devolução simbólica de mercadoria vendida ou utilizada em processo industrial, recebida anteriormente em consignação mercantil ou industrial"
  },
  {
    "codigo": "6920",
    "descricao": "Remessa de vasilhame ou sacaria"
  },
  {
    "codigo": "6921",
    "descricao": "Devolução de vasilhame ou sacaria"
  },
  {
    "codigo": "6922",
    "descricao": "Lançamento efetuado a título de simples faturamento decorrente de venda para entrega futura"
  },
  {
    "codigo": "6923",
    "descricao": "Remessa de mercadoria por conta e ordem de terceiros, em venda à ordem ou em operações com armazém geral ou depósito fechado"
  },
  {
    "codigo": "6924",
    "descricao": "Remessa para industrialização por conta e ordem do adquirente da mercadoria, quando esta não transitar pelo estabelecimento do adquirente"
  },
  {
    "codigo": "6925",
    "descricao": "Retorno de mercadoria recebida para industrialização por conta e ordem do adquirente da mercadoria, quando aquela não transitar pelo estabelecimento do adquirente"
  },
  {
    "codigo": "6931",
    "descricao": "Lançamento efetuado em decorrência da responsabilidade de retenção do imposto por substituição tributária, atribuída ao remetente ou alienante da mercadoria, pelo serviço de transporte realizado por transportador autônomo ou por transportador não inscrito na unidade da Federação onde iniciado o serviço"
  },
  {
    "codigo": "6932",
    "descricao": "Prestação de serviço de transporte iniciada em unidade da Federação diversa daquela onde inscrito o prestador"
  },
  {
    "codigo": "6933",
    "descricao": "Prestação de serviço tributado pelo ISSQN"
  },
  {
    "codigo": "6934",
    "descricao": "Remessa simbólica de mercadoria depositada em armazém geral ou depósito fechado"
  },
  {
    "codigo": "6949",
    "descricao": "Outra saída de mercadoria ou prestação de serviço não especificado"
  },
  {
    "codigo": "7000",
    "descricao": "SAÍDAS OU PRESTAÇÕES DE SERVIÇOS PARA O EXTERIOR"
  },
  {
    "codigo": "7100",
    "descricao": "VENDAS DE PRODUÇÃO PRÓPRIA OU DE TERCEIROS"
  },
  {
    "codigo": "7101",
    "descricao": "Venda de produção do estabelecimento"
  },
  {
    "codigo": "7102",
    "descricao": "Venda de mercadoria adquirida ou recebida de terceiros"
  },
  {
    "codigo": "7105",
    "descricao": "Venda de produção do estabelecimento, que não deva por ele transitar"
  },
  {
    "codigo": "7106",
    "descricao": "Venda de mercadoria adquirida ou recebida de terceiros, que não deva por ele transitar"
  },
  {
    "codigo": "7127",
    "descricao": "Venda de produção do estabelecimento sob o regime de “drawback”"
  },
  {
    "codigo": "7129",
    "descricao": "Venda de produção do estabelecimento ao mercado externo de mercadoria industrializada sob o amparo do Regime Aduaneiro Especial de Entreposto Industrial sob Controle Informatizado do Sistema Público de Escrituração Digital (Recof-Sped)."
  },
  {
    "codigo": "7200",
    "descricao": "DEVOLUÇÕES DE COMPRAS PARA INDUSTRIALIZAÇÃO, PRODUÇÃO RURAL, COMERCIALIZAÇÃO OU ANULAÇÕES DE VALORES"
  },
  {
    "codigo": "7201",
    "descricao": "Devolução de compra para industrialização ou produção rural"
  },
  {
    "codigo": "7202",
    "descricao": "Devolução de compra para comercialização"
  },
  {
    "codigo": "7205",
    "descricao": "Anulação de valor relativo à aquisição de serviço de comunicação"
  },
  {
    "codigo": "7206",
    "descricao": "Anulação de valor relativo a aquisição de serviço de transporte"
  },
  {
    "codigo": "7207",
    "descricao": "Anulação de valor relativo à compra de energia elétrica"
  },
  {
    "codigo": "7210",
    "descricao": "Devolução de compra para utilização na prestação de serviço"
  },
  {
    "codigo": "7211",
    "descricao": "Devolução de compras para industrialização sob o regime de drawback"
  },
  {
    "codigo": "7212",
    "descricao": "Devolução de compras para industrialização sob o regime de Regime Aduaneiro Especial de Entreposto Industrial sob Controle Informatizado do Sistema Público de Escrituração Digital (Recof-Sped)."
  },
  {
    "codigo": "7250",
    "descricao": "VENDAS DE ENERGIA ELÉTRICA"
  },
  {
    "codigo": "7251",
    "descricao": "Venda de energia elétrica para o exterior"
  },
  {
    "codigo": "7300",
    "descricao": "PRESTAÇÕES DE SERVIÇOS DE COMUNICAÇÃO"
  },
  {
    "codigo": "7301",
    "descricao": "Prestação de serviço de comunicação para execução de serviço da mesma natureza"
  },
  {
    "codigo": "7350",
    "descricao": "PRESTAÇÕES DE SERVIÇO DE TRANSPORTE"
  },
  {
    "codigo": "7358",
    "descricao": "Prestação de serviço de transporte"
  },
  {
    "codigo": "7500",
    "descricao": "EXPORTAÇÃO DE MERCADORIAS RECEBIDAS COM FIM ESPECÍFICO DE EXPORTAÇÃO"
  },
  {
    "codigo": "7501",
    "descricao": "Exportação de mercadorias recebidas com fim específico de exportação"
  },
  {
    "codigo": "7504",
    "descricao": "Exportação de mercadoria que foi objeto de formação de lote de exportação"
  },
  {
    "codigo": "7550",
    "descricao": "OPERAÇÕES COM BENS DE ATIVO IMOBILIZADO E MATERIAIS PARA USO OU CONSUMO"
  },
  {
    "codigo": "7551",
    "descricao": "Venda de bem do ativo imobilizado"
  },
  {
    "codigo": "7552",
    "descricao": "Saída de produtos destinados ao uso ou consumo de bordo, em embarcações ou aeronaves exclusivamente em tráfego internacional com destino ao exterior"
  },
  {
    "codigo": "7553",
    "descricao": "Devolução de compra de bem para o ativo imobilizado"
  },
  {
    "codigo": "7556",
    "descricao": "Devolução de compra de material de uso ou consumo"
  },
  {
    "codigo": "7650",
    "descricao": "SAÍDAS DE COMBUSTÍVEIS, DERIVADOS OU NÃO DE PETRÓLEO E LUBRIFICANTES"
  },
  {
    "codigo": "7651",
    "descricao": "Venda de combustível ou lubrificante de produção do estabelecimento"
  },
  {
    "codigo": "7654",
    "descricao": "Venda de combustível ou lubrificante adquirido ou recebido de terceiros"
  },
  {
    "codigo": "7667",
    "descricao": "Venda de combustível ou lubrificante a consumidor ou usuário final"
  },
  {
    "codigo": "7900",
    "descricao": "OUTRAS SAÍDAS DE MERCADORIAS OU PRESTAÇÕES DE SERVIÇOS"
  },
  {
    "codigo": "7930",
    "descricao": "Lançamento efetuado a título de devolução de bem cuja entrada tenha ocorrido sob amparo de regime especial aduaneiro de admissão temporária"
  },
  {
    "codigo": "7949",
    "descricao": "Outra saída de mercadoria ou prestação de serviço não especificado"
  }
]
